import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import dossierSlice from './slices/dossierSlice';
import referenceSlice from './slices/referenceSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    dossiers: dossierSlice,
    references: referenceSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;